import { useEffect } from 'react';

import { useCashClosure } from '../../hooks/cash/useCashClosure';
import { useCashSession } from '../../hooks/cash/useCashSession';

import CashSessionHeader from '../CashStatus/CashSessionHeader';
import CashSessionStats from '../CashStatus/CashSessionStats';
import CashSessionFooter from '../CashStatus/CashSessionFooter';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';

const CashClosureSessionCard = () => {
  const { closureStarted, start, complete } = useCashClosure();

  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  if (!activeSession) {
    return <EmptyCashSessionState />;
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <CashSessionHeader
        onAction={closureStarted ? complete : start}
        actionLabel={closureStarted ? 'Finalizar Corte Z' : 'Iniciar Corte Z'}
        actionColor={closureStarted ? '#28A745' : '#DC3545'} // rojo = cierre
      />

      <CashSessionStats
        registerName={activeSession.registerName}
        userName={activeSession.openedByName}
        openingTime={activeSession.openedAt}
      />

      <CashSessionFooter currentBalance={activeSession.currentBalance} />
    </div>
  );
};

export default CashClosureSessionCard;
